import {SortableColumn, SortHeader} from 'common';
import {Table, TableHeadProps} from 'evergreen-ui';
import {Sort} from 'pagination';
import React, {ElementType, memo} from 'react';
import {Referral} from 'referral';
import {BehaviorSubject, Observable} from 'rxjs';

export type ReferralListColumn = Omit<SortableColumn<Referral>, 'name'> & {
    name: keyof Referral | 'communications';
    basis?: string;
    size: number;
    render?: ElementType<{ referral: Partial<Referral> }>;
};

type HeadersProps = {
    isRunning$: Observable<boolean>,
    currentSort$: BehaviorSubject<Sort<Referral>>;
    columns: Readonly<ReferralListColumn[]>;
    disableSortColumns?: string[];
} & TableHeadProps;
export const ReferralListHeaders = memo(({
                                             currentSort$,
                                             isRunning$,
                                             columns,
                                             disableSortColumns = [],
                                             ...rest
                                         }: HeadersProps) => {
    return (
        <Table.Head height='2.5rem' paddingLeft="36px" borderBottom="none" {...rest}>
            {columns.map((def) => <SortHeader key={def.name as string}
                                              columnDefinition={def as SortableColumn<Referral>}
                                              isRunning$={isRunning$}
                                              disableClick={disableSortColumns?.includes(def.name)}
                                              currentSort$={currentSort$}
                                              buttonClassName='portal-ev-th-td'
                                              flexBasis={def.basis ?? '1rem'}
                                              flexShrink={def.size}
                                              flexGrow={def.size}
            />)}
        </Table.Head>
    );
});
